import { useEffect, useState } from "react";

import { checkDeviceWS, deleteDeviceWS } from "../../api/settingsApi";

import { gestioneSnackbar } from "../../../../utils/common";
import { Form, Stack } from "react-bootstrap";
import { registerPushNotifications } from "../../../../utils/pushManager";

import { t } from "i18next";

function NotificationToggle({ value, IconMenu }) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // Controlla se il dispositivo è già registrato
  useEffect(
    () => {
      const checkDevice = async () => {
        if (!localStorage.getItem("accessToken")) return;

        try {
          const reg = await navigator.serviceWorker.ready;
          const sub = await reg.pushManager.getSubscription();

          if (sub) {
            const { endpoint } = sub.toJSON();

            checkDeviceWS({ endpoint })
              .then((res) => setEnabled(res.is_registered))
              .catch((err) => console.error(err));
          }
        } catch (err) {
          console.error("Errore durante il controllo del dispositivo:", err);
        }
      };

      checkDevice();
    },
    [localStorage.getItem("accessToken")],
    Notification.permission
  );

  // Gestisce attivazione/disattivazione notifiche
  const handleToggle = async () => {
    if (!localStorage.getItem("accessToken")) return;

    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.ready;

      const currentSubscription = await reg.pushManager.getSubscription();

      if (enabled && currentSubscription) {
        // Disattivazione
        const { endpoint } = currentSubscription.toJSON();
        await deleteDeviceWS({ endpoint });
        const unsubscribed = await currentSubscription.unsubscribe();
        if (unsubscribed) {
          console.log("Sottoscrizione disattivata dal browser");
        }

        setEnabled(false);
      } else if (!enabled) {
        if (Notification.permission === "denied")
          alert(
            "Hai bloccato il permesso delle notifiche per sbloccarlo devi andare in impostazioni, notifiche ed abilitare la nostra pagina web."
          );

        // A questo punto il permesso è garantito e puoi sottoscrivere
        await registerPushNotifications({
          setState: setEnabled,
        });
      }
    } catch (err) {
      console.error("Errore attivando/disattivando notifiche:", err);
    } finally {
      setLoading(false);
    }

    //console.log("Service Worker support:", "serviceWorker" in navigator);
    //console.log("Notification permission:", Notification.permission);
    //const reg = await navigator.serviceWorker.ready;
    //const sub = await reg.pushManager.getSubscription();
    //console.log("Subscription:", sub);
  };

  return (
    <div className="container-single-item-settings">
      <Stack direction="horizontal" className="single-item-settings">
        <div>
          {IconMenu ? <IconMenu className="single-item-icon" /> : null}
          {value ? <span className="single-item-value">{t(value)}</span> : null}
        </div>
        <Form>
          <Form.Check
            type="switch"
            id="notifications-switch"
            checked={enabled}
            onChange={handleToggle}
            disabled={!localStorage.getItem("accessToken") || loading}
          />
        </Form>
      </Stack>
      <hr />
    </div>
  );
}

export default NotificationToggle;
